export default __webpack_public_path__ + "static/media/adobe.174d0887.svg";